document.querySelectorAll('.js-show-more-trigger').forEach(trigger => {
    trigger.addEventListener('click', event => {
        event.preventDefault();
        const showMoreWrapper = trigger.closest('.js-show-more-wrapper');
        showMoreWrapper?.classList.toggle('is-open');
    });
});
